export default __webpack_public_path__ + "static/media/star.d825c774.svg";